import { render, staticRenderFns } from "./WalletDataBlock.vue?vue&type=template&id=56ac674d&"
import script from "./WalletDataBlock.vue?vue&type=script&lang=js&"
export * from "./WalletDataBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports